import { createReducer } from '@reduxjs/toolkit' ;
import { getStartedPageRequest, getStartedPageSuccess, getStartedPageFailure, getStartedPageReset } from '../actions/getStartedAction';

const initialState = {
	loading: false,
	error: null,
	responseData: null,
};
	
const getStartedReducer = createReducer(initialState, (builder) => {
	builder
	.addCase(getStartedPageRequest, (state) => {
		state.loading = true;
		state.error = null;
		state.responseData = null;
	})
	.addCase(getStartedPageSuccess, (state, action) => {
		state.loading = false;
		state.responseData = action.payload;
	})
	.addCase(getStartedPageFailure, (state, action) => {
		state.loading = false;
		state.error = action.payload;
	})
	.addCase(getStartedPageReset, (state, action) => {
		state.loading = false,
		state.error = null,
		state.responseData = null
	})
});
	
export default getStartedReducer;
